module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-01-5fae12793a60312120b55e339b454bf5.jpg";